import { external, production } from './environment.production'

export const environment = {
  ...production,
  ...external,
  BASEURL: '',
  PORTNUMBER: '01',
  INST_OTHER: '/inst/other/',
  INST_PLANS: '/api/inst/plans/',
  INST_EMPLOYEES: '/api/inst/employees/',
  OLD_MPM_53080: '/us/',
  BASEURL_EQUITY_CARD: 'https://api.vanguard.com',
  // From Old Mpm "dyanamic-resource-constants.jsp" '${endpointConfigBean.awsHostUrl}'
  AWS_HOST_URL: 'https://api.cf.opsp.c1.vanguard.com',
  // Enviroment set for AWS_HOST_URL
  ENV_TYPE: 'production',
  BASE_HREF: '/dcrkpublic/',
  MEDALLIA_FID: 2101, // always-on Medallia form
  MEDALLIA:
    'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/IIG_external_libs/wdcusprem/13700/onsite/medallia-digital-embed.js',
  MDIGITAL_ON_PREM_PREFIX:
    'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/IIG_external_libs/',
  ADOBE_ANALYTICS_URL:
    'https://corp.etm.assets.vgdynamic.info/files/mpm_prd/379f26abac75/d719abb88d28/launch-4ead538a1d25.min.js',
  // The IIG_CONSULTANT_HUB_URL value is different in the internal and external versions of this environment file
  IIG_CONSULTANT_HUB_URL:
    'https://institutional.vanguard.com/portal/client/home',
 // SYS_LEVEL:"PROD"
}
